import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { actions as cmsActions } from '../../../reducers/cms.reducer';
import Button from '../../common/Button.react';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
var PageDelete = function PageDelete() {
  var _useParams = useParams(),
    userID = _useParams.userID;
  var dispatch = useDispatch();
  var activeUserID = useSelector(function (s) {
    return s.auth.user.id;
  });
  if (userID === activeUserID) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Delete User"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Button, {
    label: "Delete",
    onClick: function onClick() {
      dispatch({
        type: cmsActions.users,
        payload: {
          formData: {
            userID: userID
          },
          method: 'delete'
        }
      });
    },
    style: {
      width: 120
    },
    requireConfirmation: true,
    type: "close"
  }))));
};
export default PageDelete;